import routes from './routes'
import others from './others'

export default {
  ...routes,
  ...others
}
